import styled from "@emotion/styled";

export const Container = styled.div`
  display: inline-block;
  @keyframes ldio-frne5vp6d3f {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
  .ldio-frne5vp6d3f div {
    position: absolute;
    width: 65px;
    height: 65px;
    border: 5px solid #ffffff;
    border-top-color: transparent;
    border-radius: 50%;
  }
  .ldio-frne5vp6d3f div {
    animation: ldio-frne5vp6d3f 1s linear infinite;
    top: 50px;
    left: 50px;
  }
  .loadingio-spinner-rolling-nzbf60oti2 {
    width: 40px;
    height: 40px;
    display: inline-block;
    overflow: hidden;
    background: rgba(NaN, NaN, NaN, 0);
  }
  .ldio-frne5vp6d3f {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(0.4);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-frne5vp6d3f div {
    box-sizing: content-box;
  }
`;
